<template>
  <div class="relative z-10 bg-neutral-100">
    <div
      id="header-top-bar"
      class="mx-auto flex max-w-screen-xl justify-end py-4 mobile:justify-center"
    >
      <a
        href="#main"
        class="border-r border-neutral-900 px-2 text-[12px] leading-[12px] text-neutral-900 opacity-0 last:border-0 hover:underline focus:opacity-100 desktop:text-[13px] desktop:leading-[13px]  "
      >
        {{ $t('toContent') }}
      </a>
      <SharedLink
        v-for="(link, i) in links"
        :key="i"
        class="border-r border-neutral-900 px-2 text-[12px] leading-[12px] text-neutral-900 last:border-0 hover:underline desktop:text-[13px] desktop:leading-[13px]"
        :link="link"
      >
        {{ link.name }}
      </SharedLink>
    </div>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  links?: { url: string; type: 'external' | 'page' | 'download'; target?: '_parent' | '_top' | '_blank' | '_self'; name?: string }[];
}

withDefaults(defineProps<Props>(), {
  links: () => [],
});
</script>
